import styled from 'styled-components';
import { animated } from 'react-spring';

export const Container = styled(animated.div)`
  background-color: ${(props) => props.theme[props.backgroundcolor]};
  border-radius: 5px;
  border: 1px solid ${(props) => props.theme[props.color]};
  color: ${(props) => props.theme[props.color]};
  font: 19px/22px ${({ theme }) => theme.primaryFont};
  margin: 10px 0;
  min-height: 53px;
  padding: 16px;
`;

export const CloseButton = styled.button`
  align-items: center;
  background: ${({ theme }) => theme.white};
  border-radius: 100%;
  border: none;
  color: ${(props) => props.theme[props.color]};
  display: flex;
  float: right;
  font-size: 13px;
  height: 25px;
  justify-content: center;
  width: 25px;

  &:hover {
    cursor: pointer;
    background: ${({ theme }) => theme.grayLight};
  }
`;
